import Logo from '../../assets/logo-white.svg';
import FacebookLogo from '../../assets/facebook-logo.svg';
import InstaLogo from '../../assets/insta-logo.svg';
import { useNavigate } from 'react-router-dom';
import '../footer/footer.css';

function Footer() {

    const navigate = useNavigate();

    const handleGoToHome = () => {
        navigate("/");
    };

    return (
        <div className='footer-container'>
            <section className='left-section'>
                <button onClick={handleGoToHome} className="logo-button" aria-label="Till startsidan">
                    <img className='logo-image' src={Logo} alt="Alpine Sport logo" />
                </button>
                <article>
                    <p>
                        Dalgatan 14<br />
                        681 32 Kristinehamn
                    </p>
                    <p>
                        0768000202
                    </p>
                    <p>
                        skicka e-post
                    </p></article>
                <article className='socials-article'>
                    <a
                        href='https://www.facebook.com/alpinesportivarmland'
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Besök oss på Facebook'
                    >
                        <img src={FacebookLogo} alt="Facebook icon" width='40' height='40' />
                    </a>
                    <a
                        href='https://www.instagram.com/alpine_._sport/'
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Besök oss på Instagram'
                    >
                        <img src={InstaLogo} alt="Instagram icon" width='40' height='40' />
                    </a>
                </article>
            </section>
            <section className='middle-section'>
                <article>
                    <p>
                        &copy; 2026 Alistair McCann
                    </p>
                </article>
            </section>
            <section className='right-section'>
                <article className='right-section-article'>
                    <h2>
                        &apos;Skiing is the best way
                        in <br />
                        the world to waste time.&apos;
                    </h2>
                    <h3>
                        Glen Plake
                    </h3>
                </article>
            </section>
        </div>
    )
}

export default Footer;